import * as React from 'react';
import S from './SimpleImage.styles';
const SimpleImage = React.forwardRef(({ alt = '', loading = 'lazy', ...otherProps }, ref) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Img, { ...otherProps, ref: ref, alt: alt, loading: loading, role: alt === '' ? 'presentation' : undefined })));
});
SimpleImage.displayName = 'SimpleImage';
export default SimpleImage;
